"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppTheme = void 0;
var AppTheme;
(function (AppTheme) {
    AppTheme[AppTheme["DEFAULT"] = 0] = "DEFAULT";
    AppTheme[AppTheme["SP_DARK"] = 1] = "SP_DARK";
    AppTheme[AppTheme["SP_LIGHT"] = 2] = "SP_LIGHT";
})(AppTheme = exports.AppTheme || (exports.AppTheme = {}));
//# sourceMappingURL=user.js.map